export { default } from './Home24Carouselv2';
